module.exports = __webpack_public_path__ + "img/bg1.248bcbe3.png";